import { Component, ElementRef } from '@angular/core';
import { NavController, NavParams, ViewController, AlertController, ToastController } from 'ionic-angular';
import { AbstractPage } from '../../_com/abstract-page';
import { StaffAction } from '../../../actions/staff.action';


/**
 * Generated class for the StaffListPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */

@Component({
  selector: 'page-signature-edit',
  templateUrl: 'signature-edit.html',
})
export class SignatureEditPage extends AbstractPage{

	data = {
    id: "",
    sign_text: ""
  };
  signatureText: any;

  constructor(
  	public navCtrl: NavController,
    public navParams: NavParams,
    public viewController:ViewController,
    public alertController:AlertController,
    public toastController:ToastController,
  	public staffAction:StaffAction,
    private el: ElementRef,
  	) {
    super();

    if (this.navParams.data.isDataExists) {
      // 投稿詳細からきた場合
      this.signatureText  = this.navParams.data.signatureText;
      this.data.sign_text = this.signatureText.sign_text;
    }

    super.readyDomAccess(this.el);
  }

  /**
   * 保存処理
   */
  save() {

    // 必須チェック
    if(this.hasInvalidRequired()){
      this.alert(this.alertController, "未入力の項目を確認してください。（" + this._el.querySelectorAll('.requiredError').length + "箇所）");
      return;
    }

    if (this.navParams.data.isDataExists) {
      this.data['id'] = this.signatureText['id'];
    }


    //登録
    this.confirm(this.alertController, "入力内容で登録します。よろしいですか？", ()=>{
      this.staffAction.saveSignMessage(this.data).subscribe((data)=>{
        this.toast(this.toastController, "登録が完了しました");
        this.navCtrl.pop();
      });
    });

  }

  /**
   * キャンセル処理
   */
  cancel(){

    //入力項目タッチ無し
    if(!this.hasTouched()){
      this.viewController.dismiss();
      return;
    }

    //入力項目タッチありで、画面を閉じる
    this.confirm(this.alertController, "画面を閉じます。よろしいですか？", ()=>{
      this.viewController.dismiss();
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/signature/edit/signature-edit.ts